import React, { useState, useRef, ChangeEvent } from 'react';
import SignatureCanvas from 'react-signature-canvas';

interface NewDischargePopupProps {
  onClose: () => void;
  onSave: (name: string, date: string, descargo: string, signature: string, evidenceFile?: File) => void;
}

const NewDischargePopup: React.FC<NewDischargePopupProps> = ({ onClose, onSave }) => {
  const [name, setName] = useState('');
  const [date, setDate] = useState('');
  const [descargo, setDescargo] = useState('');
  const [evidenceFile, setEvidenceFile] = useState<File | undefined>(undefined);
  const sigCanvas = useRef<SignatureCanvas>(null);

  const handleFileChange = (event: ChangeEvent<HTMLInputElement>) => {
    if (event.target.files && event.target.files[0]) {
      setEvidenceFile(event.target.files[0]);
    }
  };

  const handleSave = () => {
    if (sigCanvas.current) {
      const signature = sigCanvas.current.getTrimmedCanvas().toDataURL('image/png');
      onSave(name, date, descargo, signature, evidenceFile);
    }
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white p-6 rounded shadow-md w-full max-w-lg">
        <h2 className="text-xl font-semibold mb-4">Nuevo Descargo</h2>
        <label className="block mb-2">
          Nombre:
          <input
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            className="block w-full mt-1 border border-gray-300 rounded p-2"
          />
        </label>
        <label className="block mb-2">
          Fecha:
          <input
            type="date"
            value={date}
            onChange={(e) => setDate(e.target.value)}
            className="block w-full mt-1 border border-gray-300 rounded p-2"
          />
        </label>
        <label className="block mb-2">
          Descargo:
          <textarea
            value={descargo}
            onChange={(e) => setDescargo(e.target.value)}
            className="block w-full mt-1 border border-gray-300 rounded p-2"
          />
        </label>
        <label className="block mb-2">
          Firma:
          <SignatureCanvas
            ref={sigCanvas}
            penColor="black"
            canvasProps={{ width: 500, height: 200, className: 'signatureCanvas block w-full mt-1 border border-gray-300 rounded p-2' }}
          />
        </label>
        <label className="block mb-2">
          Evidencia (PDF):
          <input
            type="file"
            accept="application/pdf"
            onChange={handleFileChange}
            className="block w-full mt-1 border border-gray-300 rounded p-2"
          />
        </label>
        <div className="flex justify-end mt-4">
          <button onClick={onClose} className="mr-2 bg-gray-500 text-white px-4 py-2 rounded">
            Cancelar
          </button>
          <button onClick={handleSave} className="bg-blue-500 text-white px-4 py-2 rounded">
            Guardar
          </button>
        </div>
      </div>
    </div>
  );
};

export default NewDischargePopup;
